"use client";

import React, { useEffect, useState } from "react";
import { Menu, Handshake } from "lucide-react";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
const navItems = [{
  label: "Features",
  href: "/FeaturesPage"
}, {
  label: "Pricing",
  href: "/#simple-pricing"
}, {
  label: "FAQ",
  href: "/#common-questions"
}];
function DesktopNav() {
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-8">
        {navItems.map((item, i) => <NavigationMenuItem key={item.label} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href} className="relative bg-transparent px-2 py-1 font-default text-sm font-medium text-foreground transition-colors hover:bg-transparent hover:text-primary focus:bg-transparent data-[active=true]:bg-transparent after:absolute after:bottom-0 after:left-1/2 after:h-[1px] after:w-0 after:-translate-x-1/2 after:bg-primary after:transition-all after:duration-300 hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileNav() {
  return <div className="flex flex-col gap-4">
      {navItems.map((item, i) => <Link key={item.label} data-index={i} to={item.href} className="font-default text-xl font-medium text-foreground transition-colors hover:text-primary">
          {item.label}
        </Link>)}
      <Link to="https://app.thebarndesk.com" className="font-default text-xl font-medium text-foreground transition-colors hover:text-primary">
        Log In
      </Link>
    </div>;
}
export default function FraternalExcellenceHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <section data-section-id="252277" id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? "border-b border-border bg-background/80 backdrop-blur-md" : "border-b border-border bg-background"}`}>
      {/* Partner announcement bar */}
      <Link to="/partners/" className="block w-full bg-primary text-primary-foreground hover:opacity-95 transition-opacity">
        <div className="container mx-auto flex items-center justify-center gap-2 px-4 py-2 text-center font-default text-[11px] sm:text-sm font-medium leading-tight">
          <Handshake className="size-4 shrink-0" strokeWidth={1.75} />
          <span>Now the official app partner of the American Spanish Goat Association</span>
          <span className="hidden sm:inline font-semibold underline underline-offset-2">See partners &rarr;</span>
        </div>
      </Link>
      <div className="container mx-auto flex h-20 items-center justify-between px-4">
        {}
        <div className="flex flex-1 items-center justify-start">
          <div className="lg:hidden">
            <Popover>
              <PopoverTrigger asChild>
                <Button variant="ghost" size="icon" className="text-foreground hover:text-primary">
                  <Menu className="size-6" />
                  <span className="sr-only">Toggle menu</span>
                </Button>
              </PopoverTrigger>
              <PopoverContent align="start" className="mt-2 w-[90vw] max-w-[300px] p-6 bg-background border-border rounded-lg shadow-lg">
                <MobileNav />
              </PopoverContent>
            </Popover>
          </div>
          <div className="hidden lg:block">
            <DesktopNav />
          </div>
        </div>
        {}
        <div className="flex shrink-0 items-center justify-center">
          <Link to="/" className="flex items-center justify-center">
            <WvcLogo className="h-10 w-auto text-primary" />
          </Link>
        </div>
        {}
        <div className="flex flex-1 items-center justify-end gap-2 md:gap-4">
          <Link to="https://app.thebarndesk.com" className="hidden sm:inline-flex items-center justify-center px-2 md:px-3 py-2 font-default font-medium text-sm md:text-base text-foreground hover:text-primary transition-colors whitespace-nowrap">
            Log In
          </Link>
          <Link to="https://thebarndesk.com/download/" className="flex items-center justify-center px-3 md:px-4 py-2 rounded-lg bg-primary text-primary-foreground hover:scale-105 transition-transform font-default font-semibold shadow-md text-sm md:text-base whitespace-nowrap">
            Download Now
          </Link>
        </div>
      </div>
    </section>;
}